var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-status-card cf-u-mr-sm-except-last",class:[
        { 'cf-c-status-card--long-title': _vm.title.length > 30 },
        { 'cf-c-status-card--single-task': _vm.task },
        { 'is-active': _vm.isActive }
    ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"cf-u-min-height-2"},[_c('h4',{staticClass:"cf-c-status-card__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._t("content"),_vm._t("footer",function(){return [_c('span',{staticClass:"cf-c-status-card_percentage-info cf-u-font-weight-bold"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }